import { Color, MaintenanceTypeAttributes } from '@/types'
import { CreateMaintenanceTypeMutation } from './__generated__/create_mutation'
import { Mutation as CreateMutation } from './create_mutation'
import { useForm } from '@/helpers/useForm'
import { useEffect } from 'react'
import { Query as TableQuery } from './table_query'
import { useNavigate } from 'react-router'

interface Props {
  onSuccess: () => void
}

export const Form = ({ onSuccess }: Props) => {
  const navigate = useNavigate()

  const {
    save,
    saveSuccess,
    formBuilder,
    mutationLoading,
    mutationData,
  } = useForm<CreateMaintenanceTypeMutation, MaintenanceTypeAttributes, never, never>({
    defaultValues: {
      name: '',
      color: Color.Black,
    },
    mutation: CreateMutation,
    resultKey: 'createMaintenanceType',
    refetchQueries: [TableQuery]
  })

  useEffect(() => { if (saveSuccess) onSuccess() }, [saveSuccess, onSuccess])

  useEffect(() => {
    if (!mutationData?.createMaintenanceType?.maintenanceType?.id) return

    navigate(`/settings/maintenance-types/${mutationData?.createMaintenanceType?.maintenanceType?.id}`)
  }, [mutationData, navigate])

  return (
    <div className="flex flex-col gap-6">
      { formBuilder.buildQueryError() }
      { formBuilder.buildField({ name: 'Name', field: 'name', type: 'text' }) }
      { formBuilder.buildField({ name: 'Color', field: 'color', type: 'color' }) }
      { formBuilder.saveButton(save, mutationLoading, saveSuccess) }
    </div>
  )
}
